import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";

export function CompanyHeader() {
	return (
		<SidebarMenu>
			<SidebarMenuItem>
				<SidebarMenuButton
					size="lg"
					className="cursor-default hover:bg-transparent"
				>
					<div className="flex aspect-square size-8 items-center justify-center">
						<img src="/intasida-icon.svg" alt="" className="size-8 text-white" />
					</div>
					<div className="grid flex-1 text-left text-sm leading-tight">
						<img src="/assets/icons/intasida-text.png" alt="" />
					</div>
				</SidebarMenuButton>
			</SidebarMenuItem>
		</SidebarMenu>
	);
}
